import { Modal } from '@mui/material'
import React, { useEffect, useState } from 'react'

const LoadingResultsModal = ({ open, handleClose, logos, text }) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    if (open) {
      setProgress(0) // Reset progress when modal opens
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev >= 100) {
            return 100 // Stay at 100% instead of resetting
          }
          return prev + 1
        })
      }, 50) // Faster animation for smoother continuous loading
      return () => {
        clearInterval(interval)
        setProgress(0)
      } // Cleanup on unmount or modal close
    }
  }, [open])
  return (
    <Modal
      open={open}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      disableScrollLock={true}>
      <div className="b-loading-results-modal">
        <div className="b-loading-results-modal__logos">
          {logos.map((logo) => (
            <img key={logo.name} src={logo.url} alt={logo.alt} />
          ))}
        </div>
        <p>{text}</p>
        <div className="progress">
          <div
            className="progress-bar"
            role="progressbar"
            style={{
              width: `${progress}%`,
            }}
            aria-valuenow={progress}
            aria-valuemin="0"
            aria-valuemax="100">
            <i className="icon icon-car"></i>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default LoadingResultsModal
